import { Component } from '@angular/core';

@Component({
  selector: 'abp-footer',
  template: ``,   // intentionally blank — footer is suppressed in this design
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
